/*
 * @File: Do not edit
 * @Contact: lyhzyy0819@gmail.com
 * @License: (C)Copyright 2018-2024
 * @Modify Time: Do not edit
 * @Author: lyh
 * @Version: 1.0
 * @Description: 
 */
/**
 * 设备检测工具
 * 用于识别设备类型和浏览器环境
 */

/**
 * 检测是否为移动设备
 * @returns {boolean} 是否为移动设备
 */
export function isMobileDevice() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /android|webos|iphone|ipad|ipod|blackberry|windows phone/i.test(userAgent);
}

/**
 * 检测是否为iOS设备
 * @returns {boolean} 是否为iOS设备
 */
export function isIOSDevice() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/i.test(userAgent);
}

/**
 * 检测是否为Android设备
 * @returns {boolean} 是否为Android设备
 */
export function isAndroidDevice() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /android/i.test(userAgent);
}

/**
 * 检测是否在微信浏览器中
 * @returns {boolean} 是否在微信浏览器中
 */
export function isWechatBrowser() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /micromessenger/i.test(userAgent);
}

/**
 * 检测是否在第三方APP内部WebView中
 * 注：此检测不一定准确，可能需要根据实际APP的UA特征调整
 * @param {string} appIdentifier - APP的UA标识符
 * @returns {boolean} 是否在指定APP的WebView中
 */
export function isInAppWebView(appIdentifier) {
  const userAgent = navigator.userAgent.toLowerCase();
  return appIdentifier && userAgent.includes(appIdentifier.toLowerCase());
}

/**
 * 获取当前设备信息
 * @returns {Object} 设备信息对象
 */
export function getDeviceInfo() {
  const userAgent = navigator.userAgent;
  const platform = navigator.platform;
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  const pixelRatio = window.devicePixelRatio || 1;
  
  return {
    userAgent,
    platform,
    isMobile: isMobileDevice(),
    isIOS: isIOSDevice(),
    isAndroid: isAndroidDevice(),
    isWechat: isWechatBrowser(),
    screenSize: {
      width: screenWidth,
      height: screenHeight,
      pixelRatio
    }
  };
}

/**
 * 根据设备类型应用不同的样式
 * @param {HTMLElement} element - 目标元素
 */
export function applyDeviceSpecificStyles(element) {
  if (!element) return;
  
  const deviceInfo = getDeviceInfo();
  
  // 移除可能的旧类名
  element.classList.remove('desktop-device', 'mobile-device', 'ios-device', 'android-device');
  
  // 添加新类名
  if (deviceInfo.isMobile) {
    element.classList.add('mobile-device');
    
    if (deviceInfo.isIOS) {
      element.classList.add('ios-device');
    } else if (deviceInfo.isAndroid) {
      element.classList.add('android-device');
    }
  } else {
    element.classList.add('desktop-device');
  }
} 